<template>
  <VcDropdown
    v-model="internalValue"
    :items="unitGroups"
    :linkClass="linkClass"
    @change="onChange"
  >
    <template #button="{ selected }">
      <span class="d-none d-md-inline" v-html="labelFor(selected?.id, false)"></span>
      <span class="d-inline d-md-none" v-html="labelFor(selected?.id, true)"></span>
    </template>

    <template #item="{ item, selected }">
      <span class="d-none d-md-inline" v-html="item['label']"></span>
      <span class="d-inline d-md-none" v-html="item['shortlabel'] || item['label']"></span>
      <span v-if="selected" class="ms-2">✓</span>
    </template>
  </VcDropdown>
</template>

<script>
import VcDropdown from '@/components/VcDropdown.vue';
import {VcConversion} from "/src/visualcrossing-core/vcconversion";
export default {
  name: 'UnitGroupDropdown',
  components: { VcDropdown },
  props: {
    modelValue: { required: true },
    linkClass: {
      type: [String, Array, Object],
      default: ''
    }
  },
  data() {
    return {
        unitGroups: VcConversion.UNITGROUPS
    };
  },
  computed: {
    internalValue: {
      get() {
        return this.modelValue;
      },
      set(val) {
        this.$emit('update:modelValue', val);
      }
    }
  },
  methods: {
    labelFor(id, short) {
      const it = this.unitGroups.find(x => x?.['id'] === id);
      if (!it) return '';
      return short
        ? (it?.['shortlabel'] ?? it?.['label'] ?? '')
        : (it?.['label'] ?? '');
    },
    onChange(val) {
      this.$emit('change', val);
    }
  }
};
</script>
